/**
 * 강의 작업 화면 왼쪽 진도 나무 칸의 **폭**을 브라우저 세션이 쥔다 (sessionStorage).
 *
 * 시험지 화면의 폴더 칸 폭(ExamPapersV2/folderPaneWidth.js)과 **같은 규약**이다 — 접두어 + 판 번호 + 계정,
 * 세션(탭을 닫으면 사라짐), 저장된 값도 다시 조임, 어떤 경우에도 던지지 않음. 값만 강의 화면 것이다:
 *  - 처음 폭 296px — 설계 W08 「트리는 약 272~320px 를 기준으로 조절하며 실제 문제 본문 폭을 먼저 확보」의 가운데.
 *  - 최소 256px — 머리줄(강의 이름 · 공유 상태 · ⋯)과 줄 두 줄 요약이 이 폭에 맞춰 짜여 있다.
 *  - 최대 440px — 오른쪽 결과 칸의 본문 글자가 12px 아래로 떨어지지 않게(본문 = 18px × 칸 폭/423) 남긴다.
 * 폴더 칸 모듈을 그대로 부르지 않는 이유: 범위(224~480)와 키가 그 모듈의 상수라, 부르면 두 화면이 폭을 나눠 쓴다.
 */

const PREFIX = 'syllabus:treeWidth:v1:';
const VERSION = 1;

export const TREE_WIDTH = Object.freeze({ min: 256, max: 440, initial: 296, step: 16 });

const keyOf = (userId) => `${PREFIX}${userId || 'anon'}`;

export function clampTreeWidth(px) {
  const n = Number(px);
  if (px == null || px === '' || !Number.isFinite(n)) return TREE_WIDTH.initial;
  return Math.round(Math.min(TREE_WIDTH.max, Math.max(TREE_WIDTH.min, n)));
}

export function readTreeWidth(userId) {
  try {
    const raw = sessionStorage.getItem(keyOf(userId));
    if (!raw) return TREE_WIDTH.initial;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.v !== VERSION) return TREE_WIDTH.initial;
    return clampTreeWidth(parsed.w);
  } catch (_) {
    return TREE_WIDTH.initial;
  }
}

export function writeTreeWidth(userId, px) {
  try {
    sessionStorage.setItem(keyOf(userId), JSON.stringify({ v: VERSION, w: clampTreeWidth(px) }));
    return true;
  } catch (_) {
    return false;
  }
}
